import React, { Component } from 'react';

export default class Footer extends Component{
  render(){
    return(
      <footer>
        <h1>Integrity Skincare</h1>
        <div className="social-icons">
          <a href="https://www.facebook.com/IntegritySkin/" targer="_blank"><i class="fab fa-facebook-square"></i></a>
          <a href="https://www.yelp.com/biz/integrity-skin-care-san-francisco" target="blank"><i class="fab fa-yelp"></i></a>
          <a href="https://www.google.com/maps/place/Integrity+Skin/@37.7958274,-122.4061882,17z/data=!3m1!4b1!4m5!3m4!1s0x8085808ad24a3255:0x3c37136add249e2b!8m2!3d37.7958274!4d-122.4039942" target="_blank"><i class="far fa-map"></i></a>
        </div>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/footer.jsx